import md5 from 'js-md5'
let scrollTop = 0
// 防抖
export function debounce(func, wait = 0, immdeiate = false) {
  let timerId
  return function () {
    var _this = this
    var args = arguments
    if (timerId) {
      clearTimeout(timerId)
    }
    if (immdeiate && !timerId) {
      func.apply(_this, args)
    }
    timerId = setTimeout(function () {
      func.apply(_this, args)
    }, wait)
  }
}
// 节流
export function throttleFirstExt(f, t) {
  let flag = true
  return (...args) => {
    if (flag) {
      f(...args)
      flag = false
      setTimeout(() => {
        flag = true
      }, t)
    }
  }
}
// 生成签名sign
export function createSign(config) {
  console.log(config)
  const paramsArr = [
    'x-aio-appid',
    'x-aio-trace-id',
    'client',
    'client-version',
    'source',
    'channel',
    'services-version',
    'time'
  ]
  let signParams = {}
  paramsArr.forEach((item) => {
    signParams[item.toLocaleLowerCase()] = config.headers[item] || ''
  })
  let signString = process.env.VUE_APP_SECRET_KEY
  Object.keys(signParams)
    .sort()
    .forEach((key) => {
      let encodeVal = encodeURIComponent(signParams[key])
      signString += `@${encodeVal}`
    })
  signString += `@${process.env.VUE_APP_SECRET_KEY}`
  signString = md5(signString).toUpperCase()
  return signString
}
export function isIOS() {
  var iosMatch = /(iPhone|iPad|iPod|iOS|Mac)/i.test(navigator.userAgent)
  return iosMatch
}

/**
 *
 * @param v1 版本号1
 * @param v2 版本号2
 * v1 > v2 返回1
 * v1 < v2 返回-1
 * v1 === v2 返回0
 * @returns
 */

export const compareVersion = (v1, v2) => {
  if (v1 == v2) {
    return 0
  }

  const vs1 = v1.split('.').map((a) => parseInt(a))
  const vs2 = v2.split('.').map((a) => parseInt(a))

  const length = Math.min(vs1.length, vs2.length)
  for (let i = 0; i < length; i++) {
    if (vs1[i] > vs2[i]) {
      return 1
    } else if (vs1[i] < vs2[i]) {
      return -1
    }
  }
  if (length == vs1.length) {
    // 不严谨todo：考虑1.7 1.7.0对比的情况
    return -1
  } else {
    return 1
  }
}

// 判断ua里面是否带版本号
export function isNewBridgeView() {
  let ua = navigator.userAgent
  let clientVersion = ''
  let seperatorEl = 'xes-bookv'
  if (!ua.includes('xes-bookv')) {
    //如果不包含直接返回false
    if (!ua.includes('xes-book')) {
      return false
    } else {
      seperatorEl = 'xes-book'
    }
  }
  let splitUA = ua.split(seperatorEl)
  clientVersion = splitUA[1]
  if (!clientVersion) {
    // 如果没有版本信息返回false
    return false
  }
  let compareVersionRes = compareVersion(clientVersion, '1.8.0')
  if (compareVersionRes == 1) {
    // 如果版本信息大于目标版本信息返回true
    return true
  }
  return false
}
export function noScroll() {
  // const body = document.querySelector('body');
  // body.style.width = '100%';
  // scrollTop = document.scrollingElement.scrollTop;  // scrollTop 存储在全局
  // body.style.position = 'fixed';
  // document.body.style.top = -scrollTop + 'px';
}
export function refreshScroll() {
  // after-open
  // document.body.style.position = 'static';
  // document.scrollingElement.scrollTop = scrollTop;
}

export function setTimeoutSync(fn = () => {}, time = 0) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      fn && fn()
      resolve()
    }, time)
  })
}
